import { render, staticRenderFns } from "./MediaUpload.vue?vue&type=template&id=a6d81d28&scoped=true"
import script from "./MediaUpload.vue?vue&type=script&lang=js"
export * from "./MediaUpload.vue?vue&type=script&lang=js"
import style0 from "./MediaUpload.vue?vue&type=style&index=0&id=a6d81d28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d81d28",
  null
  
)

export default component.exports